import script from "./CreatedChannel.vue?vue&type=script&setup=true&lang=js"
export * from "./CreatedChannel.vue?vue&type=script&setup=true&lang=js"

import "./CreatedChannel.vue?vue&type=style&index=0&id=4c219e6a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c219e6a"]])

export default __exports__